module.exports = __webpack_public_path__ + "img/NoProfile.2c70340c.jpg";